import React, { Component } from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

class SimpleTableHead extends Component {
	createSortHandler = property => event => {
		const { onRequestSort } = this.props;
		onRequestSort(event, property);
	};

	render() {
		const {
			columns
		} = this.props;

		return (
			<TableHead>
				<TableRow>
					{columns.map(headRow => (
						<TableCell
							key={headRow.id}
							align={headRow.numeric ? 'right' : 'left'}
							padding={headRow.disablePadding ? 'none' : 'default'}
						>
							{headRow.label}
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		);
	}
}

export default SimpleTableHead;



// WEBPACK FOOTER //
// ./src/components/tableSimple/SimpleTableHead.js